import axios from 'axios';
import urlParse from 'url-parse';
import Vue from 'vue';
import router from '../router';
import store from '../store';

const isProduction = process.env.NODE_ENV === 'production';

const currentProtocol = isProduction ? 'https' : 'http';

const apiPort = process.env.API_PORT || 8080;

let apiBaseUrl = '/api/v1';

if (!isProduction) {
  // Api Url build
  const apiBaseUrlBuilder = urlParse('');
  apiBaseUrlBuilder.set('protocol', currentProtocol);
  apiBaseUrlBuilder.set('hostname', 'localhost');
  apiBaseUrlBuilder.set('pathname', '/api/v1');
  if (apiPort) {
    apiBaseUrlBuilder.set('port', apiPort);
  }

  apiBaseUrl = apiBaseUrlBuilder.toString();
}

const base = axios.create({
  baseURL: apiBaseUrl
});

// Add a the header authorization with each request
base.interceptors.request.use(
  config => {
    const token = Vue.$storage.get('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// When 401 remove token
base.interceptors.response.use(null, error => {
  if (error.response && error.response.status === 401) {
    store.dispatch('logout').then(() => {
      router.push('/login');
    });
  }
  return Promise.reject(error);
});

Vue.prototype.$http = base;

export default base;
